<template>
  <!-- 切换组织 -->
  <h-dialog
    title="组织列表"
    v-model="isShow"
    :confirmLoading="loading"
    @onOk="ok"
    @onCancel="cancel"
    width="500"
  >
    <div style="width: 100%; max-height: 500px; overflow-y: auto;padding: 20px 0;">
      <el-radio-group v-model="selectedOrgId">
        <el-tree
          v-loading="treeLoading"
          class="tree_container"
          style="width: 100%"
          :props="formatTreeKV"
          :data="treeData"
          node-key="id"
          highlight-current
          default-expand-all
          ref="treeRef"
          :expand-on-click-node="false"
          @node-click="treeClick"
        >
          <template #default="{ node, data }">
            <el-radio
              :label="data.id"
              @change="handleRadioChange(node, data.id)"
              class="custom-radio"
            >
              {{ node.label }}
            </el-radio>
          </template>
        </el-tree>
      </el-radio-group>
    </div>
  </h-dialog>
</template>

<script setup>
import { getTreeList } from "@/api/common";
import { ElMessage } from "element-plus";
import { ref } from "vue";

/* 当前选中的组织ID */
const selectedOrgId = ref(null);

/* 树形组件格式 */
const formatTreeKV = {
  label: `name`,
  org_list: `org_list`,
  id: `id`,
};

/* 树形组织展示 */
const treeData = ref([]);

const treeLoading = ref(false);

/* 获取树形列表所有元素 */
const getTreeData = async () => {
  treeLoading.value = true;
  let {
    error,
    result: { data },
  } = await getTreeList({ type: 1 });
  if (!error) {
    treeData.value = formatTreeData([data]);
    treeLoading.value = false;
  }
};

/* 处理树形组织数据 */
const formatTreeData = (data) => {
  return data.map((item) => {
    const node = {
      id: item.id,
      name: item.name,
      level: item.level,
      org_code: item.org_code,
    };

    // 如果有子节点（org_list），递归转换为 children
    if (item.org_list && item.org_list.length > 0) {
      node.children = formatTreeData(item.org_list);
    }
    return node;
  });
};

/* 处理点击树节点 */
const treeClick = (curNode) => {
  // console.log("<>> ", curNode);
  selectedOrgId.value = curNode.id; // 确保树节点点击时能更新选中的值
};

/* 处理单选框变化 */
const handleRadioChange = (node, orgId) => {
  selectedOrgId.value = orgId;
};

const isShow = ref(false);
const loading = ref(false);

const emits = defineEmits(['success']);

const ok = () => {
  if (!selectedOrgId.value) {
    ElMessage({
      message: `请选择组织`,
      type: `error`,
    });
    return;
  }
  emits('success', selectedOrgId.value);
};

function cancel() {
  // 可以在这里添加取消的处理逻辑
}

const toggleShow = () => {
  getTreeData();
  isShow.value = true;
  selectedOrgId.value = null; // 清除已选择的组织
};

defineExpose({
  toggleShow,
});
</script>

<style lang="scss" scoped>
/* 树组件样式 */
.tree_container :deep(.el-tree-node.is-current > .el-tree-node__content) {
  background: #ffffff !important;
}

.tree_container :deep(.el-tree) {
  .el-tree-node__content {
    position: relative;
  }

  .el-tree-node:last-child > .el-tree-node__content::before {
    content: "";
    width: 1px;
    height: 10000px;
    background-color: #00000015;
    position: absolute;
    margin-left: -9px;
    bottom: 13px;
  }

  .el-tree-node__children .el-tree-node__content::after {
    content: "";
    width: 9px;
    height: 1px;
    background-color: #00000015;
    position: absolute;
    margin-left: -9px;
  }

  .el-tree-node__content > .el-tree-node__expand-icon {
    padding: 6px 3px;
  }
}

:deep(.custom-radio .el-radio__inner) {
  border-radius: 4px !important;
  width: 18px !important;
  height: 18px !important;
  border-color: #dcdfe6 !important;
}

:deep(.custom-radio .el-radio__inner::after) {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' color='white' width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6 9 17l-5-5'/%3E%3C/svg%3E");
  width: 100% !important;
  height: 100% !important;
  display: flex;
  justify-content: center;
  color: white;
  background: var(--primary-color);
  border-radius: 3px;
}

.custom-radio {
  margin-right: 10px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
}
</style>
